angular.module('jv.Admin.Users')
    .factory('modalObjectTemplateFAC', [function () {
        return {
            get: function(typeObject) {
                return {
                    type: typeObject.name.toUpperCase(),
                    show: true,
                    headText: typeObject.title,
                    showCC: false,
                    showBCC: false,
                    showLinks: false,
                    templates: [],
                    templatePlaceHolder: typeObject.placeholder,
                    subjectPlaceHolder: typeObject.subjectPlaceholder
                };
            },
            setDefault: function(templates) {
                var selectedTemplate = {};
                angular.forEach(templates, function(templt){
                    if(templt['default']){
                        selectedTemplate.template = templt;
                        selectedTemplate.subject = templt.subject;
                        selectedTemplate.body = templt.body;
                    }
                });
                return selectedTemplate;
            }
        };
    }])
    .controller('jvAdminUsersDataSyncEmployeeListController',
        ['$scope', 'adminUserSVC','$rootScope', '$location', '$route', 'breadcrumbsResolve', 'enumToValueMap', 'commonListActionsFAC', '$timeout', 'modalObjectTemplateFAC',
            function($scope, adminUserSVC, $rootScope, $location, $route, breadcrumbsResolve, enumToValueMap, commonListActionsFAC, $timeout, modalObjectTemplateFAC) {

                $scope.flags.loading = false;
                $scope.showResults = false;
                $scope.flags.expanded = true;
                $scope.employeeDataSyncLogCount = 0;
                $scope.employeeDataSyncCount = true;
                var isPaginate = false;  //This variable will be toggled to get list on first page for any change in filter/sort which trigger employee search
                $scope.employeeSelect = adminUserSVC.employeeSelect;
                $scope.resultCount = -1;

                $scope.breadcrumbsConfig = breadcrumbsResolve;
                $scope.filters = {
                		'page' : 0,
                		'pageSize' : 10
                };
                
            	$scope.status = 'ALL';
            	$scope.statusList = [ {value:'ALL', label:i18n['ALL']},
            	                      {value:'COMPLETED', label:i18n['ADMIN_USERS_DATA_SYNC_STATUS_FILTER_SUCCESS']},
            	                      {value:'FAILED', label:i18n['ADMIN_USERS_DATA_SYNC_STATUS_FILTER_FAILED']}
            	                     ];
            	
            	$scope.dates = {};
            	$scope.filterType = { filterType: 'daterange' };
                $scope.showDeleteThresholdAlert=false;
                $scope.employeesToDelete=null;
                $scope.employeesProcessed=null;
                $scope.deleteRecordsInPercentage=null;
                $scope.deleteThresholdConfigured=null;
                $scope.pausedJobExecutionId=null;
                $scope.recordsEnd = function() {
                    if ($scope.filters) {
                    	if($scope.resultCount < 1) {
                    		return 0;
                    	} else {
                            return Math.min($scope.filters.pageSize * ($scope.filters.page + 1), $scope.resultCount);
                    	}
                    }
                };

                $scope.recordsStart = function() {
                	 if ($scope.filters) {
                     	if($scope.resultCount < 1) {
                     		return 0;
                     	} else {
                            return $scope.filters.pageSize * $scope.filters.page + 1;
                     	}
                     }
                };
                $scope.next = function() {
                    if ($scope.filters.page < $scope.resultCount / $scope.filters.pageSize - 1) {
                        $scope.filters.page++;
                        $scope.getEmployeeListFilters();
                    }
                };
                $scope.prev = function() {
                    if ($scope.filters.page !== 0) {
                        $scope.filters.page--;
                        $scope.getEmployeeListFilters();
                    }
                };
                
                $scope.employeeDataSyncLogs = [];
               
                $scope.downloadEmployeeSyncFile = function(url) {
                	adminUserSVC.downloadEmployeeSyncFile(url);
                }
                
                $scope.downloadTemplate = function() {
                	adminUserSVC.downloadTemplate();
                }
                
                $scope.showSyncTypeDetail = function() {
                	alert("showSyncTypeDetail");
                }
                
                $scope.showResults = function(resultExists) {
                	$scope.showResults = true;
                }
                
                $scope.hideResults = function() {
                	$scope.hideResults = false;
                }
                
                $scope.openImportModal = function() {
                	$rootScope.$broadcast('showImportEmployeeModal', "datasync");
                }
                
                var refreshListPage = $rootScope.$on('refreshListPage', function(event, data) {
                	 $scope.filters.page = 0;
                	 $scope.getEmployeeListFilters();
                });
                
                var importedEmployeeDataSyncFile = $rootScope.$on('importedEmployeeDataSyncFile', function(event, data) {
                	var sendInviteEmail = data.sendInviteEmail;
                	var fullSync = data.fullSync;
                    var resetSync = data.resetSync;
                    var considerExclusionList = data.considerExclusionList;
                    var key = data.uploadedFile.employeeSyncKey;
                    var fileName = data.uploadedFile.fileName;
                    var fileDelimiter = data.fileDelimiter;
                    $scope.fileName = data.uploadedFile.fileName;
                	adminUserSVC.import(key, fileName, sendInviteEmail, fullSync, resetSync, considerExclusionList, fileDelimiter, function(response){
                		$rootScope.$broadcast('showImportEmployeeConfirmationModal', response);
                	});
                });
                
                $scope.importFile = function(data) {
                	var sendInviteEmail = data.sendInviteEmail;
                	var fullSync = data.fullSync;
                    var resetSync = data.resetSync;
                    var considerExclusionList = data.considerExclusionList;
                    var key = data.uploadedFile.employeeSyncKey;
                    var fileName = data.uploadedFile.fileName;
                    var fileDelimiter = data.fileDelimiter;
                    $scope.fileName = data.uploadedFile.fileName;
                	adminUserSVC.import(key, fileName, sendInviteEmail, fullSync, resetSync, considerExclusionList, fileDelimiter, function(response){
                		$scope.flags.loading = false;
                		$rootScope.$broadcast('showImportEmployeeConfirmationModal', response);
                	});
                };
                
                var submit = $rootScope.$on('submit', function(event, data) {
                	$scope.flags.loading = true;
                	if(data && data.mapping.columnMappingId && (data.mapping.columnMappingId).trim() !== "") {
                		adminUserSVC.updateMapping(data.mapping, function(response){
                			$scope.importFile(data);
                    	});
                	} else {
                		adminUserSVC.submit(data.mapping, function(response){
                    		$scope.importFile(data);
                    	});
                	}
                });
                
                var getColumnsMapping = $rootScope.$on('getColumnsMapping', function(event, data) {
                	adminUserSVC.getColumnMapping(data, function(response){
                		$rootScope.$broadcast('getColumnsMappingResponse', response);
                	});
                });
                
                var getSelects2MappingValues = $rootScope.$on('getSelects2MappingValues', function(event, data) {
                	adminUserSVC.getSelect2MappingValues(data, function(response){
                		$rootScope.$broadcast('getSelects2MappingValuesResponse', response);
                	});
                });
                
                $scope.$watch('dates', function(newVal, oldVal) {  
                	 if ((newVal === undefined) || (newVal.from === undefined) || (newVal.to === undefined)) {
                		 return; // skip the initialization
                	 }
                	 
                	 if (newVal.type != oldVal.type) {
                		 // optimization to skip the change in dropdown type; the change will be processed on a subsequent call that updates the date values themselves
                		 return;
                	 }
                	 
                  	 $scope.filters.page = 0;
                	 $scope.getEmployeeListFilters();  // this is also called on initial page load
                 }, true);
                
                
                $scope.filtersChanged = function() {
                  	 $scope.filters.page = 0;
                	 $scope.getEmployeeListFilters();                	
                }
                
                $scope.getEmployeeListFilters = function() {
                	$scope.flags.loading = true;
                	$scope.employeeDataSyncLogs = [];
                	var args = {
                		'page' : $scope.filters.page,
                		'pageSize' : $scope.filters.pageSize,
                		'status' : $scope.status,
                		'from' : $scope.dates.from,
                		'to' : $scope.dates.to
                	};
                	adminUserSVC.getLogs(args, function(response){
                		$scope.flags.loading = false;
                		$scope.employeeDataSyncLogs = [];
                		if(response && response.totalElements && response.executions) {
                			$scope.resultCount = response.totalElements;
                			$scope.employeeDataSyncLogCount = response.totalElements;
                			if(response.pageSize) {
                				$scope.filters.pageSize = response.pageSize;
                			}
                			for(var i = 0 ; i < response.executions.length ; i++) {
                				$scope.employeeDataSyncLogs.push({
                					'syncType':'-',
                        			'fileName':'-',
                        			'fileSize': '-',
                        			'started': '-',
                        			'completed': '-',
                        			'status': '-',
                        			'sourceFile': '-',
                        			'summaryFile': '-',
                        			'showCounters':false,
                        			'showDownloadSummary': false
                				});
                				if (response.executions[i]) {
                					if(response.executions[i].job && response.executions[i].job.connector && response.executions[i].job.connector.type) {
                						$scope.employeeDataSyncLogs[i].syncType = response.executions[i].job.connector.type;
                    				}
									
									if(response.executions[i].multiFileProcessed === true && response.executions[i].fileName){
										$scope.employeeDataSyncLogs[i].fileName = response.executions[i].fileName;
									} else if(response.executions[i].job && response.executions[i].job.connector && response.executions[i].job.connector.parameters && response.executions[i].job.connector.parameters.displayFileName){
										$scope.employeeDataSyncLogs[i].fileName = response.executions[i].job.connector.parameters.displayFileName;
									}
                    				
                					if(!!response.executions[i].sourceFileInBytes >= 0) {
                						$scope.employeeDataSyncLogs[i].fileSize = response.executions[i].sourceFileInBytes+'k';
                    				}
                					if(response.executions[i].startTime) {
                						$scope.employeeDataSyncLogs[i].started = response.executions[i].startTime;
                					}
                					if(response.executions[i].endTime) {
                						$scope.employeeDataSyncLogs[i].completed = response.executions[i].endTime;
                					}
                					if(response.executions[i].status) {
                						$scope.employeeDataSyncLogs[i].status = response.executions[i].status.toLowerCase();
                					}
                					if(response.executions[i].sourceFile) {
                						$scope.employeeDataSyncLogs[i].sourceFile = response.executions[i].sourceFile;
                					}
                					if(response.executions[i].summaryFile) {
                						$scope.employeeDataSyncLogs[i].summaryFile = response.executions[i].summaryFile;
                					}
                					if(response.executions[i].counters) {
                						$scope.employeeDataSyncLogs[i].counters = response.executions[i].counters;
                						$scope.employeeDataSyncLogs[i].showCounters = true;
                					}
                					if(response.executions[i].job && response.executions[i].job.createdBy) {
                						$scope.employeeDataSyncLogs[i].createdBy = response.executions[i].job.createdBy;
                					}
                					if(response.executions[i].hasWarnings) {
                						$scope.employeeDataSyncLogs[i].showDownloadSummary = response.executions[i].hasWarnings;
                					}
                				}
                				if($scope.employeeDataSyncLogs[i].syncType && $scope.employeeDataSyncLogs[i].syncType === "S3") {
                					$scope.employeeDataSyncLogs[i].syncType = i18n['ADMIN_USERS_DATA_SYNC_UPLOAD_TYPE_MANUAL'];
                				} else if($scope.employeeDataSyncLogs[i].syncType && $scope.employeeDataSyncLogs[i].syncType === "SFTP") {
                					$scope.employeeDataSyncLogs[i].syncType = i18n['ADMIN_USERS_DATA_SYNC_UPLOAD_TYPE_SCHEDULED'];
                				}
                			}
                		}
                		if(window.location.href.indexOf('?jobExecutionid=')>0){
                			$scope.pausedJobExecutionId=$location.search().jobExecutionid;
                			$scope.showDeleteThresholdPauseAlert();
                		}
                	});
                }
                
                $scope.$on('$destroy', function() {
                	refreshListPage();
                	importedEmployeeDataSyncFile();
                	submit();
                	getColumnsMapping();
                	getSelects2MappingValues();
                });
              
               $scope.showDeleteThresholdPauseAlert = function(){
            	   var args={};
            	   args.jobExecutionId=$scope.pausedJobExecutionId;
            	   adminUserSVC.getJobExecutionDetails(args,function(response){
            		   if(response!=""){
            			   $scope.showDeleteThresholdAlert=true; 
                		   $scope.employeesToDelete=response.totalRecordsToDelete;
                		   $scope.employeesProcessed=response.totalEmployeeFullSyncStageRecords;
                		   $scope.deleteRecordsInPercentage=response.totalDeleteRecordsInPercentage;
                		   $scope.deleteThresholdConfigured=response.job.customData.thresholdPercentage;
            		   }else{
            			   $location.url($location.path());
            		   }
            	   });
               };
               $scope.proceedPausedSync=function(){
            	   var args={};
            	   args.jobExecutionId=$scope.pausedJobExecutionId;
            	   args.userAction="PROCEED";
            	   adminUserSVC.submitPausedJobForSync(args,function(response){
            		   $scope.showDeleteThresholdAlert=false;
            		   $location.url($location.path());
            		   refreshListPage();
            	   });
               };
               $scope.cancelPausedSync = function(){
            	   var args={};
                   args.jobExecutionId=$scope.pausedJobExecutionId;
                   args.userAction="CANCEL";
            	   adminUserSVC.cancelJobState(args,function(response){
            		   $scope.showDeleteThresholdAlert=false;
            		   $location.url($location.path());
            		   refreshListPage();
            	   });
               };
               $scope.hideModal = function(){
                   $location.url($location.path());
            	   $scope.showDeleteThresholdAlert=false;
               };
        	}
    ]);
